export default "__VITE_ASSET__DJKzyOdV__"